/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import textStyles from '../../foundations/textStyles'

export default {
    baseStyle: {
        container: {
            display: 'flex',
            alignItems: 'center',
            gap: 3
        },
        label: {
            width: 'full',
            // reset base styles
            marginStart: null
        },
        control: {
            backgroundColor: 'stokkeCore.white',
            border: '1px',
            borderColor: 'stokkeCore.black',
            // use boxSize to set the width and height of the control, and differ from base style sizes which use w and h,
            // so they can be reset in the size variants
            boxSize: 6,
            _checked: {
                backgroundColor: 'stokkeCore.black',
                borderColor: 'stokkeCore.black',
                _before: {
                    w: 2,
                    h: 2
                },
                _hover: {
                    backgroundColor: 'stokkeCore.black',
                    borderColor: 'stokkeCore.black'
                }
            },
            _focus: {
                boxShadow: 'none'
            },
            _indeterminate: {}
        }
    },
    variants: {
        field: {
            label: {
                ...textStyles['Regular 2XLarge']
            }
        },
        focused: {
            label: {
                ...textStyles['Regular 2XLarge']
            },
            control: {
                _focus: {
                    boxShadow: 'outline'
                }
            }
        }
    },
    sizes: {
        md: {
            control: {
                // reset base styles
                w: null,
                h: null
            },
            label: {
                ...textStyles['Regular Medium']
            }
        },
        lg: {
            control: {
                // reset base styles
                w: null,
                h: null
            },
            label: {
                ...textStyles['Regular 2XLarge']
            }
        }
    },
    defaultProps: {
        size: 'lg'
    }
}
